<template>
  <div class="proxy-history">
    <!-- 交易类型筛选（从后端获取） -->
    <van-tabs v-if="cateGoryList && cateGoryList.length" v-model:active="activeCategoryIndex" @change="onCategoryChange" class="category-tabs" scrollable>
      <van-tab v-for="(cat, idx) in cateGoryList" :key="idx" :title="cat.dcField2" :name="idx"></van-tab>
    </van-tabs>
    <!-- 状态子Tabs（圆角按钮样式） -->
    <div class="status-tabs">
      <button v-for="st in statusList" :key="st.value" :class="['status-item', daichongForm.status === st.value ? 'active' : '']" @click="selectStatus(st.value)">
        {{ st.label }}
      </button>
    </div>
    <!-- 交易记录列表 -->
    <div class="order-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多记录" @load="onLoad">
          <div v-for="item in list" :key="item.id" class="order-item" @click="viewDetail(item)">
            <div class="order-header">
              <div class="order-info">
                <span class="order-id">订单号:{{ item.orderNo }}</span>
                <span class="order-time">{{ item.orderTime }}</span>
              </div>
              <div class="header-right">
                <van-button class="contact-btn" @click.stop.prevent="contactUs" icon="service-o">联系我们</van-button>
              </div>

            </div>
            <div class="order-content">
              <div class="order-left">
                <van-image :src="item.gameAvatar" class="thumb" fit="cover" />
              </div>
              <div class="order-main">
                <div class="title">{{ item.gdUserField1 }}</div>
                <div class="price-row">
                  <span class="amount">¥{{ item.ppAmount }}</span>
                </div>
              </div>
              <div class="order-right">
                <div class="quantity">x{{ item.gameId || 1 }}</div>
                <div class="status">
                  <span v-if="item.status == 1">待发货</span>
                  <span v-else-if="item.status == 3">已取消</span>
                  <span v-else-if="item.status == 4">已完成</span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <!-- 空状态 -->
    <!-- 详情弹窗 -->
    <van-popup v-model:show="showDetail" position="bottom" :style="{ height: '50%' }" round>
      <div class="detail-popup">
        <div class="detail-header">
          <h3>交易详情</h3>
          <van-icon name="cross" @click="showDetail = false" />
        </div>
        <div v-if="selectedItem" class="detail-content">
          <div class="detail-section">
            <van-cell title="订单号" :value="selectedItem.orderNo" />
            <van-cell title="金额" :value="'¥' + selectedItem.ppAmount" />
            <van-cell title="数量" :value="'x'+selectedItem.gameId || 1" />
            <van-cell title="描述" :value="selectedItem.gdUserField1" />
            <van-cell title="时间" :value="selectedItem.orderTime" />
            <van-cell title="状态">
              <template #value>
                <span class="value" v-if="selectedItem.status == 1">待发货</span>
                <span class="value" v-if="selectedItem.status == 3">已取消</span>
                <span class="value" v-if="selectedItem.status == 4">已完成</span>
              </template>
            </van-cell>
            <van-cell title="订单凭证">
              <template #value>
                <van-image :src="selectedItem.depositVoucher" fit="contain" alt="订单凭证" width="50px" height="50px" />
              </template>
            </van-cell>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { showToast } from 'vant';
import request from '@/utils/request'
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 0,
      pageSize: 10,
      refreshing: false,
      showDetail: false,
      selectedItem: null,
      daichongForm: {},
      cateGoryList: [],
      activeCategoryIndex: 0,
      statusList: [
        {value: '5', label: '全部'},
        {value: '1', label: '待发货'},
        {value: '4', label: '已完成'},
        {value: '3', label: '已取消'}
      ]
    };
  },
  created() {
    this.page = 1;
    this.getAllCateGory();
  },
  methods: {
    getAllCateGory() {
      request.get('/front/deposit/getAllSubCateGoryList')
        .then(res => {
          if (res.code == 200) {
            this.cateGoryList = res.data;
            // 默认选中第一个分类
            if (this.cateGoryList && this.cateGoryList.length > 0) {
              this.daichongForm.selectedCategory = this.cateGoryList[0].configType;
              this.activeCategoryIndex = 0;
              this.daichongForm.status = '5';
              this.getList();
            }
          }
        })
    },
    getList() {
      if (this.finished) {
        return false
      }
      request.get('/front/game/deposit/list', {
        params: {
          pageNum: this.page,
          pageSize: 10,
          orderNo: this.daichongForm.orderNo,
          status: this.daichongForm.status,
          depositType: this.daichongForm.selectedCategory,
        }
      }).then(res => {
        if (res.code == 200) {
          console.log(res)
          if (this.page == 1) {
            this.list = res.rows;
          } else {
            this.list = [...this.list, ...res.rows];
          }
          // 判断是否还有更多数据
          this.finished = this.list.length >= res.total;
          console.log(this.finished)
        } else {
          this.finished = true;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    onLoad() {
      setTimeout(() => {
        this.page++;
        this.getList();
      }, 500);
    },
    onRefresh() {
      console.log(123)
      this.refreshing = true;
      setTimeout(() => {
        this.list = [];
        this.page = 1;
        this.finished = false;
        this.getList();
        this.refreshing = false;
      }, 500);
    },
    // 选择分类
    selectCategory(cat) {
      this.daichongForm.selectedCategory = cat;
      this.page = 1;
      this.list = [];
      this.finished = false;
      this.getList();
    },
    onCategoryChange(index) {
      const idx = Number(index);
      if (this.cateGoryList && this.cateGoryList[idx]) {
        this.activeCategoryIndex = idx;
        this.selectCategory(this.cateGoryList[idx].configType);
      }
    },
    // 选择状态（子 tab）
    selectStatus(status) {
      this.daichongForm.status = status;
      this.page = 1;
      this.list = [];
      this.finished = false;
      this.getList();
    },
    viewDetail(item) {
      this.selectedItem = item;
      this.showDetail = true;
    }
    ,
    contactUs() {
      window.open("https://work.weixin.qq.com/kfid/kfc0afede0891281246");
    }
  }
};
</script>

<style scoped>
.proxy-history {
  background-color: #f7f8fa;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.order-list {
  padding: 16px;
  overflow-y: scroll;
  min-height: 0;
}

.category-tabs {
  padding: 8px 16px;
  background: transparent;
}
.category-list {
  display: flex;
  gap: 8px;
  overflow-x: auto;
}
.category-item {
  padding: 6px 12px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #ebedf0;
  cursor: pointer;
  white-space: nowrap;
}
.category-item.active {
  background: #1989fa;
  color: #fff;
  border-color: #1989fa;
}

.status-tabs {
  padding: 8px 16px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.status-item {
  padding: 6px 12px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #ebedf0;
  cursor: pointer;
}
.status-item.active {
  background: #1989fa;
  color: #fff;
  border-color: #1989fa;
}

.order-item {
  background: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.order-item:active {
  transform: scale(0.98);
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.order-info {
  flex: 1;
}

.order-id {
  font-size: 14px;
  font-weight: 500;
  color: #323233;
  display: block;
  margin-bottom: 4px;
}

.order-time {
  font-size: 12px;
  color: #969799;
}

.order-status {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.status-success {
  color: #07c160;
}

.status-failed {
  color: #f53f3f;
}

.order-content {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  align-items: center;
}

.order-avatar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.order-details {
  flex: 1;
}

.order-left .thumb {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  object-fit: cover;
}

.order-main {
  flex: 1;
  padding: 0 12px;
}

.title {
  font-size: 18px;
  font-weight: 700;
  color: #111;
  margin-bottom: 6px;
}

.price-row .amount {
  color: #ee0a24;
  font-size: 18px;
  font-weight: 700;
}

.order-right {
  width: 88px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}

.order-right .quantity {
  font-size: 16px;
  color: #333;
  margin-bottom: 4px;
  text-align: right;
  font-weight: 700;
}

.order-right .status {
  color: #ee0a24;
  font-size: 26px;
  font-weight: 900;
  line-height: 1;
}

.header-right {
  display: flex;
  align-items: center;
}

.contact-btn {
  background: #07c160;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.contact-btn:active { opacity: 0.85 }

.detail-row {
  display: flex;
  margin-bottom: 6px;
  font-size: 14px;
}

.detail-row:last-child {
  margin-bottom: 0;
}

.label {
  color: #646566;
  width: 80px;
  flex-shrink: 0;
}

.value {
  color: #323233;
  flex: 1;
}

.price-row .price {
  color: #ee0a24;
  font-weight: 600;
}

/* 详情弹窗样式 */
.detail-popup {
  padding: 20px;
  height: 100%;
  overflow-y: auto;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebedf0;
}

.detail-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #323233;
}

.detail-section {
  margin-bottom: 24px;
}
</style>